import React, { useEffect, useRef, useState } from 'react'
import { Column } from 'primereact/column'
import CofinsCstService from "./cofinsCstService"
import FormList from 'base/FormList'

export default function CofinsCstList() {

    const [service] = useState(() => new CofinsCstService())
    const toast = useRef(null)
    const searchData = {
        pkName: 'codigo_cofcst',
        dsName: 'descricao_cofcst',
        mainField: { name: 'descricao_cofcst', label: 'Descrição' },
        advFields: [
            { name: 'codigo_cofcst', label: 'Código', type: 'string', inputMode: 'text' },
            { name: 'descricao_cofcst', label: 'Descrição', type: 'string', inputMode: 'text' },
        ]
    }

    useEffect(() => {
    }, [service])

    return (
        <FormList service={service} toast={toast} searchData={searchData} showActions={true}>
            <Column field="codigo_cofcst" sortable header="Código"></Column>
            <Column field="descricao_cofcst" sortable header="Descrição"></Column>
        </FormList >
    )
}
